import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {

        getAwards(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/award/v1/getAwards`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateAward(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/award/v1/updateAward/${data.id}`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        }, 

        addAward(ctx, data){
            return new Promise((resolve, reject) => {
                axios
                    .post(`/award/v1/addAward`, data)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        deleteAward(ctx, id){
            return new Promise((resolve, reject) => {
                axios
                    .delete(`/award/v1/deleteAward/${id}`)
                    .then(response => resolve(response))
                    .catch(error => reject(error))
            })
        },

        updateOrdering(ctx, queryParams) {
            const data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/award/v1/updateOrdering', data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}